function resultQuestions(formQuestions) {
  const keys = Object.keys(formQuestions)
  let sumPoints = 0
  for (let i = 0; i < keys.length; i += 1) {
    sumPoints += formQuestions[keys[i]]
  }
  return Math.ceil(sumPoints / keys.length)
}

const questionsVuex = {
  data() {
    return {
      confirmEmail: this.$store.state.diagnosis.email,
      form: { ...this.$store.state[this.keyForm] }
    }
  },
  methods: {
    rangeChange(newValue, id) {
      this.form[id] = newValue
      this.$store.commit('UPDATE_FIELD', {
        form: this.keyForm,
        key: id,
        value: newValue
      })
    }
  },
  beforeDestroy() {
    console.log(this.keyForm, this.form, resultQuestions(this.form))
    this.$store.commit('UPDATE_FIELD', {
      form: 'results',
      key: `td_score_${this.keyForm}`,
      value: resultQuestions(this.form)
    })
  }
}

export default questionsVuex;



// WEBPACK FOOTER //
// ./src/components/mixins/questionsVuex.js